// src/pages/WiderrufsbelehrungPage.js
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const WiderrufsbelehrungPage = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
      <Paper elevation={3} sx={{ maxWidth: 800, p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Widerrufsbelehrung
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>Widerrufsrecht</strong>
          <br />
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Ware in Besitz genommen haben bzw. hat.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns ([Dein Unternehmen], [Adresse], [E-Mail-Adresse], [Telefonnummer]) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.</strong>
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>Folgen des Widerrufs</strong>
          <br />
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.
        </Typography>
      </Paper>
    </Box>
  );
};

export default WiderrufsbelehrungPage;
